<template>
  <v-row no-gutters :class="`ap-list-item ${status.className}`">
    <v-col class="ap-list-item_date" :cols="layout['1']">
      <span class="ap-list-item_date_time">{{ `${startTime} - ${endTime}` }}</span>
      <span class="ap-list-item_date_text">{{ formattedDate }}</span>
      <span class="ap-list-item_status_row" v-if="$vuetify.breakpoint.xsOnly">
        <div class="ap-list-item_status_circle" />
        {{ status.name }}
      </span>
    </v-col>
    <v-col v-if="!$vuetify.breakpoint.xsOnly" class="ap-list-item_profile centered-flex" :cols="layout['2']">
      <v-list-item class="username-block">
        <v-list-item-avatar>
          <Avatar :userId="userId" />
        </v-list-item-avatar>

        <v-list-item-content>
          <span class="heading-5">{{ userName }}</span>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col v-if="!$vuetify.breakpoint.xsOnly" class="ap-list-item_chief-complaint" :cols="layout['3']">
      <div class="cc-wrap">
        <v-list-item-title class="sub-heading-3">{{ $t("visits.chiefComplaint") }}</v-list-item-title>
        <v-list-item-subtitle class="heading-6">
          {{ translateChiefComplaint(item.chiefComplaint) }}
        </v-list-item-subtitle>
      </div></v-col
    >
    <v-col v-if="!$vuetify.breakpoint.xsOnly" class="centered-flex ap-list-item_status" :cols="layout['5']"
      ><span class="centered-flex ap-list-item_status_row"
        ><div class="centered-flex ap-list-item_status_circle"></div>
        {{ status.name }}</span
      ></v-col
    >
    <v-col class="centered-flex ap-list-item_buttons" :cols="layout['6']">
      <span v-if="item.status === 'planned' && place === 'upcoming'" class="ap-list-item_cancel-btn" @click="cancel">
        {{ $t("practitioner.appointments.cancelVisit") }}
      </span>
      <OutlinedButton
        v-if="!joinNow"
        additionalClassName="outlined-btn__green"
        :text="!smBreakpoint ? $t('practitioner.appointments.viewDetails') : ''"
        :icon="!smBreakpoint ? '' : '$vuetify.icons.details'"
        :disabled="!['planned', 'in-progress', 'finished', 'triaged'].includes(item.status)"
        @onClick="viewDetailsClick"
      />
      <PrimaryButton v-else :text="$t('visits.waiting.joinVisit')" @onClick="viewDetailsClick" />
    </v-col>
  </v-row>
</template>
<script>
import { DateTime, Interval } from "luxon";

import Avatar from "@/components/Avatar/Index";
import OutlinedButton from "@/components/uikit/OutlinedButton";
import PrimaryButton from "@/components/uikit/PrimaryButton";

export default {
  name: "AppoitnmentsListItem",
  props: ["item", "role", "today", "place"],
  components: {
    OutlinedButton,
    PrimaryButton,
    Avatar,
  },
  computed: {
    startTime() {
      return DateTime.fromISO(this.item.start).toFormat("t");
    },
    endTime() {
      return DateTime.fromISO(this.item.end).toFormat("t");
    },
    formattedDate() {
      return DateTime.fromISO(this.item.start).toFormat("d MMMM yyyy");
    },
    userName() {
      return this.item[this.role === "practitioner" ? "patient" : "practitioner"].name;
    },
    userId() {
      return this.item[this.role === "practitioner" ? "patient" : "practitioner"].id;
    },
    layout() {
      const layout = {
        1: "2",
        2: "3",
        3: "2",
        4: "4",
        5: "1",
        6: "4",
      };
      if (this.place === "archive") {
        layout["5"] = "2";
        layout["6"] = "3";
      }

      if (this.$vuetify.breakpoint.xsOnly) {
        layout["1"] = "8";
        layout["6"] = "4";
      }

      return layout;
    },
    isToday() {
      if (!this.item) {
        return false;
      }
      const { start } = this.item;
      return DateTime.fromISO(start).startOf("day") === DateTime.local().startOf("day");
    },
    status() {
      const status = {};
      switch (this.item.status) {
        case "planned":
          status.className = this.isToday ? "ap-list-item_upcoming" : "ap-list-item_scheduled";
          status.name = this.isToday ? this.$t("general.status.upcoming") : this.$t("general.status.scheduled");
          break;
        case "in-progress":
          status.className = "ap-list-item_active";
          status.name = this.isToday ? this.$t("general.status.upcoming") : this.$t("general.status.active");
          break;
        case "triaged":
          status.className = "ap-list-item_unsigned";
          status.name = this.$t("general.status.pending");
          break;
        case "finished":
          status.className = "ap-list-item_signed";
          status.name = this.$t("general.status.signed");
          break;
        case "cancelled":
          status.className = "ap-list-item_cancelled";
          status.name = this.$t("general.status.cancelled");
          break;
      }
      return status;
    },
    joinNow() {
      const startDate = DateTime.fromISO(this.item.start);
      const now = DateTime.fromJSDate(new Date());
      const interval = Interval.fromDateTimes(now, startDate);
      return interval.length("minutes") < 3;
    },
    smBreakpoint() {
      return window.outerWidth < 481;
    },
  },
  methods: {
    cancel() {
      this.$emit("onCancel", this.item.appointmentId);
    },
    viewDetailsClick() {
      this.$emit("onButtonClick", this.item.id);
    },
    translateChiefComplaint(val) {
      return this.$t("general.chiefComplaints")[val] || val || "-";
    },
  },
};
</script>

<style lang="scss" scoped>
.username-block {
  width: inherit;
}
.cc-wrap {
  width: inherit;
}
</style>
